export const BREAKPOINTS = {
  Mobile: 375,
  Tablet: 834,
  LargeTablet: 1090,
  Desktop: 1440
};
